import { Link } from "react-router-dom";
import { Eyebrow, SectionTitle } from "../Eyebrow";

export const STEPS = [
    ["01", "Analyse", "Analyse de l'ensemble de vos frais bancaires sur les 12 derniers mois."],
    ["02", "Calcul", "Calcul des indicateurs clés et identification des commissions bancaires les plus coûteuses."],
    ["03", "Optimisation", "Négociation avec vos banques actuelles ou, si elles ne correspondent plus à votre stratégie, présentation de nouveaux partenaires."],
];

const CASES = [
    ["Affacturage", "Transporteur · Centre-Val de Loire · ~8 M€ de CA", "−40 K€", "Renégociation avec les banques et le factor, en 26 jours."],
    ["International · crédoc", "Industriel défense et aéronautique · Occitanie · ~30 M€", "−102 K€", "75 % du CA à l'export, 4 banques. Obtenu en 24 jours."],
    ["Monétique · flux", "Groupe de franchisés multi-sites · ~40 M€", "−73 K€", "80 % du CA encaissé par TPE, 7 banques. En 45 jours."],
];

export const MethodSection = ({ steps = STEPS, children }) => (
    <section className="mx-auto max-w-[1240px] px-4 md:px-8 lg:px-12 py-10 md:py-16 lg:py-20 flex flex-col gap-6 md:gap-8" data-testid="home-method">
        <div className="flex flex-col gap-3">
            <Eyebrow>Notre méthode</Eyebrow>
            <SectionTitle>Un process rapide en 3 étapes.</SectionTitle>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-6">
            {steps.map(([n, title, txt], i) => (
                <article
                    key={n}
                    data-testid={`how-step-${n}`}
                    className={`bg-white rounded-[14px] p-5 md:p-[26px] flex flex-col gap-2 md:gap-3 border-t-4 transition-transform duration-300 hover:-translate-y-1 ${
                        i === steps.length - 1 ? "border-gold" : "border-navy"
                    }`}
                >
                    <span className="font-bold text-[15px] text-gold-text">{n}</span>
                    <h3 className="m-0 text-xl font-bold">{title}</h3>
                    <p className="m-0 text-[15px] leading-relaxed text-grey-text-soft">{txt}</p>
                </article>
            ))}
        </div>
        {children}
    </section>
);

export const CasesSection = () => (
    <section className="bg-cream border-y border-border-default" data-testid="home-cases">
        <div className="mx-auto max-w-[1240px] px-4 md:px-8 lg:px-12 py-10 md:py-16 lg:py-20 flex flex-col gap-5 md:gap-8">
            <div className="flex flex-wrap justify-between items-end gap-x-3 gap-y-1">
                <div className="flex flex-col gap-3">
                    <Eyebrow>Cas clients</Eyebrow>
                    <SectionTitle>Trois dossiers, trois familles de frais.</SectionTitle>
                </div>
                <Link to="/tarifs" data-testid="home-cases-more" className="text-[15px] font-semibold text-navy underline underline-offset-4 hover:text-gold-text inline-flex items-center min-h-[44px]">
                    Voir un cas en détail
                </Link>
            </div>
            <div data-testid="home-cases-track" className="-mx-4 px-4 md:mx-0 md:px-0 flex md:grid md:grid-cols-3 gap-4 md:gap-5 overflow-x-auto md:overflow-visible snap-x snap-mandatory scroll-px-4 pb-2 md:pb-0 [scrollbar-width:none] [&::-webkit-scrollbar]:hidden">
                {CASES.map(([tag, title, amount, txt]) => (
                    <article key={tag} className="snap-start shrink-0 w-[84%] md:w-auto bg-white border border-border-default rounded-xl p-5 md:p-[26px] flex flex-col gap-3">
                        <span className="text-[13px] md:text-xs font-semibold uppercase tracking-[0.12em] text-grey-text-soft">{tag}</span>
                        <h3 className="m-0 text-base font-semibold leading-[1.45]">{title}</h3>
                        <span className="font-bold text-[36px] md:text-[42px] leading-none tracking-[-0.02em] text-navy tabular-nums">
                            {amount} <span className="text-[17px] font-medium">/ an</span>
                        </span>
                        <p className="m-0 text-sm leading-[1.55] text-grey-text-soft">{txt}</p>
                    </article>
                ))}
            </div>
        </div>
    </section>
);
